import React from "react";
import RecomendationComponentLazyLoad from "./RecomendationComponentLazyLoad";

const ProductBrowsingHistory: React.FC = () => {
  return (
    <RecomendationComponentLazyLoad
      recommendationsPageName="product-page-v2-2"
      trackingEventName="browse history loaded"
    />
  );
};

export default ProductBrowsingHistory;
